// Sesli / titreşimli geri bildirim (WebAudio + navigator.vibrate). Kullanıcı etkileşimi sonrası çalışır.
let ctx = null;
const getCtx = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
  } catch { return null; }
};

const tone = (freq, dur, delay = 0, type = "sine", gain = 0.25) => {
  const c = getCtx();
  if (!c) return;
  const o = c.createOscillator(); const g = c.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, c.currentTime + delay);
  g.gain.exponentialRampToValueAtTime(gain, c.currentTime + delay + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + delay + dur);
  o.connect(g).connect(c.destination);
  o.start(c.currentTime + delay); o.stop(c.currentTime + delay + dur + 0.02);
};

const vibrate = (p) => { try { navigator.vibrate?.(p); } catch { /* yok */ } };

export const beepReady = () => { tone(880, 0.08); vibrate(40); };
export const beepSuccess = () => { tone(880, 0.1); tone(1320, 0.18, 0.11); vibrate([60, 40, 120]); };
export const beepWarn = () => { tone(440, 0.15, 0, "square", 0.15); tone(440, 0.15, 0.2, "square", 0.15); vibrate([150, 80, 150]); };
export const beepError = () => { tone(220, 0.4, 0, "sawtooth", 0.15); vibrate([300, 100, 300]); };
export const unlockAudio = () => getCtx();
